module.exports = __webpack_public_path__ + "img/rear.a8a12bb7.png";